// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8RuTW","text":"styles_text__wmtoZ"};